import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { LOGIN_TYPE } from '@services/waves-connector.service';
import * as plutoActions from '@stores/pluto.actions';
import { map, Observable } from 'rxjs';
import { selectPluto } from '@stores/pluto.selectors';

export interface ILoginType {
  value: LOGIN_TYPE;
  name: string;
  icon: string;
}

@Component({
  selector: 'app-select-login-type-modal',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './select-login-type-modal.component.html',
  styleUrl: './select-login-type-modal.component.scss',
})
export class SelectLoginTypeModalComponent {
  constructor(private readonly _store: Store) {}

  protected showFromStore$: Observable<boolean> = this._store
    .select(selectPluto)
    .pipe(map(({ showLoginModal }) => showLoginModal));

  protected showFromStore: Signal<boolean> = toSignal(this.showFromStore$, {
    initialValue: false,
  });

  protected loginTypeSelected: WritableSignal<LOGIN_TYPE | null> =
    signal<LOGIN_TYPE | null>(null);

  protected selectLoginType(loginType: LOGIN_TYPE) {
    this.loginTypeSelected.set(loginType);
    this.onLoginTypeSelected.emit(this.loginTypeSelected()!);
    this._store.dispatch(plutoActions.selectLoginType({ loginType }));
    this.onClose.emit();
  }

  protected showModal: Signal<boolean> = computed(
    () => this.showFromStore() || this.show(),
  );

  protected close(): void {
    this._store.dispatch(plutoActions.hideLoginModal());
    this.onClose.emit();
  }

  public loginTypes: InputSignal<ILoginType[]> = input.required();

  public show: InputSignal<boolean> = input(false);

  public onLoginTypeSelected: OutputEmitterRef<LOGIN_TYPE> =
    output<LOGIN_TYPE>();

  public onClose: OutputEmitterRef<void> = output();
}
